import type { DraggableAttributes, DraggableSyntheticListeners } from '@dnd-kit/core';
import SolarIcon from 'components/icons/SolarIcon';

export interface SortableDragHandleProps {
    attributes: DraggableAttributes;
    listeners: DraggableSyntheticListeners;
}

const SortableDragHandle = ({ attributes, listeners }: SortableDragHandleProps) => (
    <button
        type="button"
        className="btn btn-link p-0 border-0 text-muted drag-handle"
        aria-label="Reorder"
        {...attributes}
        {...listeners}
    >
        <SolarIcon name="grip-vertical" />
    </button>
);

export default SortableDragHandle;
